import * as R from 'ramda'
import { renderProcessName } from '../../process/util/names'


export const getProcessSelectList = (processStateNameList) => {
    const processNameList = []
    R.forEachObjIndexed((value, key) => {
        processNameList.push({
            id: key,
            value: renderProcessName(key),
        })
    }, processStateNameList)
    return processNameList
}

export const getStateSelectList = (processStateNameList, processName) => {
    const currentProcess = processStateNameList[processName]
    const stateNameList = []
    if (currentProcess) {
        R.forEach(stateName => {
            stateNameList.push({
                id: stateName,
                value: stateName,
            })
        }, currentProcess)
    }
    stateNameList.sort((a, b) => {
        if (a.id < b.id) { return -1 }
        if (a.id > b.id) { return 1 }
        return 0
    })
    return stateNameList
}



// WEBPACK FOOTER //
// ./src/modules/analytics/state/helper.js